<template>
  <div>
    <div class="card" @click="goEval">
      <img v-lazy="item.evaluation.classify_image" class="testImg" />
      <div class="detail">
        <p class="h2 mt-10">{{ item.evaluation.title }}</p>
        <span class="f10 fr mr-10 mt-5 gray">{{ item.gift_date }}</span>
        <p class="f10">
          兑换码： <span class="f14 lightyellow">{{ item.redeem_code }}</span>
        </p>
        <div class="duihuan0" v-if="item.is_change.key === 'no'"></div>
        <div class="duihuan1" v-if="item.is_change.key === 'yes'"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Card",
  props: {
    item: Object,
    type: String,
  },
  data() {
    return {};
  },
  created() {
    console.log("this.item");
    console.log(this.item);
  },
  methods: {
    // 评价
    goEval() {
      if (this.type) {
        localStorage.setItem("testId", this.item.evaluation.id);
        this.$router.push("/my/sendDetail/" + this.item.redeem_code);
      } else {
        this.$router.push("/test/" + this.item.evaluation.id + "/introduction");
      }
    },
  },
};
</script>

<style lang='less' scoped>
.card {
  width: 100%;
  .testImg {
    width: 32%;
    height: 96px;
    border-radius: 12px;
    margin: 10px;
  }
  .detail {
    float: right;
    width: 60%;
    margin-right: 10px;
    font-size: 15px;
    .h2 {
      height: 70px;
      line-height: 0.6rem;
    }
    .duihuan0 {
      background: url("./../assets/img/my/toexchange.png") no-repeat center
        center;
      width: 100px;
      height: 100px;
      background-size: 80%, 80%;
      margin-left: 50%;
      margin-top: -80px;
    }
    .duihuan1 {
      background: url("./../assets/img/my/exchanged.png") no-repeat center
        center;
      width: 100px;
      height: 100px;
      background-size: 80%, 80%;
      margin-left: 50%;
      margin-top: -80px;
    }
  }
}
</style>
<style lang='less'>
.van-tab--active {
  .van-tab__text {
    color: #42686e;
  }
}
.van-tabs__line {
  background-color: #42686e;
  /*width: 100%;*/
}
</style>